<script setup lang="ts">
import { ref } from "vue";
import { useLogStore } from "@/stores/log";

const props = defineProps<{
  deviceId: string;
  userId?: string;
  orderId?: string;
  note?: string;
}>();

const message = ref("");
const errorText = ref("");
const writing = ref(false);
const logStore = useLogStore();
const write = async () => {
  if (!message.value) {
    errorText.value = "Enter a message";
  }
  writing.value = true;
  await logStore.write(
    message.value,
    props.deviceId,
    props.userId,
    props.orderId,
  );
  message.value = "";
  writing.value = false;
};
</script>

<template>
  <h2>Add note to log</h2>
  <p v-if="props.note">{{ props.note }}</p>
  <pn-input
    v-model="message"
    label="Message"
    helpertext=""
    :error="errorText"
    placeholder=""
    v-on:input="errorText = ''"
  />
  <p>
    <pn-button small="true" v-on:click="write" :loading="writing">
      Send
    </pn-button>
  </p>
</template>
